<div class="card">
    <div class="card-header">
        <h5>{{'PROPERTIES.Odaberite tip forme' | translate}}</h5>
    </div>

    <div class="card-body">
        <div class="col-12 col-lg-6">
            <div class="input-group p-0 px-lg-1 rounded">
                <input class="form-control" type="search" [placeholder]="'DASHBOARD.Pretraga' | translate"
                    aria-label="Search" aria-describedby="search-addon" [(ngModel)]="search" (keyup)="filterItems()" />
                <button (click)="filterItems()" class="btn btn-light input-group-text">
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </div>

        <ul class="list-group mt-2">
            @for (item of filteredTipoviFormi; track $index) {
            <li class="list-group-item" href="javascript:void(0)" (click)="listSelected(item.sifra)">
                <div class="main-box"> {{ item.naziv }}</div>
            </li>
            }
        </ul>

        <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-light me-3" (click)="closeModal()">
                {{"PROPERTIES.Odustani" | translate}}
            </button>
        </div>
    </div>
</div>